import { defineMessages, type MessageDescriptor } from 'react-intl';

import {
	EXTERNAL_PRODUCT_CONNECTION,
	type ExternalProductConnection,
} from './__types__/RemoteObject.ts';

const messages = defineMessages({
	googleDrive: {
		id: 'space-curation.review-content-suggestions-modal.filter-source-google-drive',
		defaultMessage: 'Google Drive',
		description: 'Display name for the Google Drive third-party source',
	},
	loom: {
		id: 'space-curation.review-content-suggestions-modal.filter-source-loom',
		defaultMessage: 'Loom',
		description: 'Display name for the Loom third-party source',
	},
	microsoft: {
		id: 'space-curation.review-content-suggestions-modal.filter-source-microsoft',
		defaultMessage: 'Microsoft',
		description: 'Display name for the Microsoft third-party source',
	},
});

export const CONNECTION_MESSAGE: Record<ExternalProductConnection, MessageDescriptor> = {
	[EXTERNAL_PRODUCT_CONNECTION.GOOGLE_DRIVE]: messages.googleDrive,
	[EXTERNAL_PRODUCT_CONNECTION.LOOM]: messages.loom,
	[EXTERNAL_PRODUCT_CONNECTION.MICROSOFT]: messages.microsoft,
};
